<cb-dialog dialogHeading="Manage Colour Schedule">
    <div class="cb-margin-bottom-2x end-center flex-row">
        <button mat-raised-button (click)="expandCollapseAll()">
            @if (!expandAll) {
                <span class="start-center flex-row">
                    <span class="flex">Expand All&nbsp;</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </span>
            }
            @if (expandAll) {
                <span class="start-center flex-row">
                    <span class="flex">Collapse All&nbsp;</span>
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </span>
            }
        </button>
    </div>
    <form class="form-container flex-col flex" #test="ngForm">
        @if (finishedLoading) {
            <mat-accordion [multi]="true">
                @for (
                    group of groupWithExpansion | cbSortByPipe: 'sortOrder' : 'asc';
                    track group
                ) {
                    <mat-expansion-panel [(expanded)]="group.expanded">
                        <mat-expansion-panel-header class="panel-heading">
                            <mat-panel-title class="start-center flex-row">
                                <mat-icon>list</mat-icon>
                                <div class="cb-margin-left-2x flex-col flex">
                                    <h1 class="mat-body-strong">
                                        {{ group.name }} ({{ getItemsSizeOnThisGroup(group.name) }})
                                    </h1>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="flex-col">
                            <div class="standardTable">
                                <table>
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            @if (data.isLotSpecScheduleItem) {
                                                <td>Product Name/Description</td>
                                            }
                                            <td style="width: 160px">Show In Colour Schedule</td>
                                        </tr>
                                    </thead>
                                    @if (!data.isLotSpecScheduleItem) {
                                        <tbody [id]="'buildStageId_' + group.id">
                                            @for (
                                                item of getItemsOnThisGroup(group.name);
                                                track item
                                            ) {
                                                <tr [id]="'buildProgrammeActivity_' + item.id">
                                                    <td>{{ item.productDisplay }}</td>
                                                    @if (
                                                        item.showInColourYourDreams !== undefined
                                                    ) {
                                                        <td style="width: 160px">
                                                            <mat-checkbox
                                                                (click)="$event.stopPropagation()"
                                                                (change)="
                                                                    onColourYourDreamFlagChange(
                                                                        $event,
                                                                        item
                                                                    )
                                                                "
                                                                [checked]="
                                                                    item.showInColourYourDreams
                                                                "
                                                            >
                                                            </mat-checkbox>
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </tbody>
                                    }
                                    <!-- Disable dragging for new specScheduleItem templates-->
                                    @if (data.isLotSpecScheduleItem) {
                                        <tbody [id]="'buildStageId_' + group.id">
                                            @for (
                                                item of getItemsOnThisGroup(group.name);
                                                track item
                                            ) {
                                                <tr [id]="'buildProgrammeActivity_' + item.id">
                                                    <td>{{ item.slotName }}</td>
                                                    @if (data.isLotSpecScheduleItem) {
                                                        <td>{{ item.productDisplay }}</td>
                                                    }
                                                    @if (
                                                        item.showInColourYourDreams !== undefined
                                                    ) {
                                                        <td style="width: 160px">
                                                            <mat-checkbox
                                                                (click)="$event.stopPropagation()"
                                                                (change)="
                                                                    onColourYourDreamFlagChange(
                                                                        $event,
                                                                        item
                                                                    )
                                                                "
                                                                [checked]="
                                                                    item.showInColourYourDreams
                                                                "
                                                            >
                                                            </mat-checkbox>
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }
            </mat-accordion>
        }
        @if (!finishedLoading) {
            <cb-loading-spinner></cb-loading-spinner>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            (click)="save()"
            [disabled]="!isFormEnabled()"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
